export const XLSX_VIEWER_STRINGS = {
  DIALOG: {
    TITLE: 'Confirm Clear Mappings',
    CONTENT: 'Are you sure you want to clear these mappings?',
    CANCEL: 'Cancel',
    CONFIRM: 'Clear Mappings',
  },

  ACCEPT_ALL_DIALOG: {
    TITLE: 'Accept All AI Suggestions',
    CONTENT: 'Are you sure you want to accept all AI suggestions for this document? This action cannot be undone.',
    CANCEL: 'Cancel',
    CONFIRM: 'Yes, proceed',
  },

  MENU: {
    CLEAR_ALL: 'Clear All Mappings for Current Measurement Date',
    CLEAR_DOCUMENT: 'Clear Current Document Mappings',
    CLEAR_SHEET: 'Clear Current Sheet',
    CLEAR_SHEET_SUFFIX: 'Mappings',
  },

  BUTTON: {
    ACCEPT_ALL: 'Accept All',
    CREATE_LABELS: 'Create Labels',
    PUSH_MAPPINGS: 'Push Mappings'
  },

  LOADING: {
    MESSAGE: 'Processing the document, this may take a moment...',
  },

  ERROR: {
    TITLE: 'Unable to load the workbook.',
    MESSAGE: 'This may be because the file is too large or there was a problem parsing the XLSX file.',
  },

  ARIA: {
    MENU_ID: 'split-button-menu',
  },
} as const;
